import {
  animate,
  state,
  style,
  transition,
  trigger
} from "@angular/animations";
import { Component, Input } from "@angular/core";

import { SidebarSubsection } from "./types";

const ANIMATION_TIME_MS = 200;

@Component({
  selector: "ta-subsection",
  templateUrl: "./subsection.template.html",
  animations: [
    trigger("collapseOut", [
      transition("* => void", [
        style({
          height: "*",
          opacity: 1,
          overflowY: "hidden"
        }),
        animate(
          ANIMATION_TIME_MS,
          style({
            height: 0,
            opacity: 0
          })
        )
      ])
    ]),
    trigger("expandIn", [
      transition("void => *", [
        style({
          opacity: 0,
          height: 0,
          overflowY: "hidden"
        }),
        animate(
          ANIMATION_TIME_MS,
          style({
            height: "*",
            opacity: 1
          })
        )
      ])
    ]),
    trigger("plusMinus", [
      state("minus", style({ transform: "rotate(0deg)" })),
      state("plus", style({ transform: "rotate(-90deg)" })),
      transition("minus <=> plus", animate(ANIMATION_TIME_MS))
    ])
  ]
})
export class SubsectionComponent {
  @Input()
  subsection: SidebarSubsection;

  @Input()
  get active(): boolean {
    return this._active;
  }
  set active(value: boolean) {
    if (this._active === value) {
      return;
    }

    this.expanded = value;

    this._active = value;
  }
  private _active: boolean = false;

  expanded: boolean = false;
  hover: boolean = false;

  toggleExpanded(): void {
    this.expanded = !this.expanded;
  }
}
